/*
 * PT Mobile Menu
 * Vanilla JavaScript controller. No jQuery. No external libraries.
 * Supports: open, close, Escape, overlay click, focus trap, scroll lock,
 * submenu toggle, multiple menus, safe reinitialisation (Theme Editor).
 */
(function () {
  'use strict';

  var SCROLL_LOCK_CLASS = 'pt-mm-scroll-locked';
  var OPEN_CLASS = 'is-open';
  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function PTMobileMenu(root) {
    this.root = root;
    this.drawer = root.querySelector('[data-pt-mm-drawer]');
    this.overlay = root.querySelector('[data-pt-mm-overlay]');
    this.closeBtn = root.querySelector('[data-pt-mm-close]');
    this.drawerId = root.getAttribute('data-pt-mm-id') || (this.drawer && this.drawer.id);
    this.triggers = [];
    this.lastFocused = null;
    this.isOpen = false;

    this.onKeydown = this.onKeydown.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);

    this.init();
  }

  PTMobileMenu.prototype.init = function () {
    if (!this.drawer) {
      return;
    }
    if (this.root.getAttribute('data-pt-mm-ready') === 'true') {
      return;
    }
    this.root.setAttribute('data-pt-mm-ready', 'true');

    this.bindTriggers();

    if (this.overlay) {
      this.overlay.addEventListener('click', this.onOverlayClick);
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.onCloseClick);
    }

    this.bindSubmenus();
  };

  PTMobileMenu.prototype.bindTriggers = function () {
    var self = this;
    var selector = '[data-pt-mm-trigger]';
    var all = document.querySelectorAll(selector);
    for (var i = 0; i < all.length; i++) {
      var trigger = all[i];
      var controls = trigger.getAttribute('aria-controls');
      if (controls && controls === self.drawerId) {
        self.triggers.push(trigger);
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          self.toggle();
        });
      }
    }
  };

  PTMobileMenu.prototype.bindSubmenus = function () {
    var toggles = this.drawer.querySelectorAll('[data-pt-mm-submenu-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      (function (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          var controls = toggle.getAttribute('aria-controls');
          var submenu = controls ? document.getElementById(controls) : null;
          if (!submenu) {
            var parent = toggle.closest('[data-pt-mm-item]') || toggle.parentNode;
            submenu = parent ? parent.querySelector('[data-pt-mm-submenu]') : null;
          }
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (submenu) {
            if (expanded) {
              submenu.setAttribute('hidden', '');
            } else {
              submenu.removeAttribute('hidden');
            }
          }
        });
      })(toggles[i]);
    }
  };

  PTMobileMenu.prototype.toggle = function () {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  };

  PTMobileMenu.prototype.open = function () {
    if (this.isOpen) {
      return;
    }
    this.lastFocused = document.activeElement;
    this.isOpen = true;

    if (this.overlay) {
      this.overlay.removeAttribute('hidden');
    }
    this.drawer.removeAttribute('hidden');
    this.root.classList.add(OPEN_CLASS);
    this.drawer.setAttribute('aria-hidden', 'false');

    for (var i = 0; i < this.triggers.length; i++) {
      this.triggers[i].setAttribute('aria-expanded', 'true');
    }

    document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    document.addEventListener('keydown', this.onKeydown);

    var self = this;
    this.drawer.focus();
    window.setTimeout(function () {
      self.focusFirst();
    }, 60);
  };

  PTMobileMenu.prototype.close = function () {
    if (!this.isOpen) {
      return;
    }
    this.isOpen = false;

    this.root.classList.remove(OPEN_CLASS);
    this.drawer.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < this.triggers.length; i++) {
      this.triggers[i].setAttribute('aria-expanded', 'false');
    }

    document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
    document.removeEventListener('keydown', this.onKeydown);

    var self = this;
    window.setTimeout(function () {
      if (!self.isOpen) {
        self.drawer.setAttribute('hidden', '');
        if (self.overlay) {
          self.overlay.setAttribute('hidden', '');
        }
      }
    }, 300);

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus();
    }
  };

  PTMobileMenu.prototype.focusFirst = function () {
    var focusable = this.getFocusable();
    if (focusable.length) {
      focusable[0].focus();
    } else {
      this.drawer.focus();
    }
  };

  PTMobileMenu.prototype.getFocusable = function () {
    var nodes = this.drawer.querySelectorAll(FOCUSABLE);
    var result = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.offsetParent !== null || node === document.activeElement) {
        result.push(node);
      }
    }
    return result;
  };

  PTMobileMenu.prototype.onKeydown = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key === 'Tab' || event.keyCode === 9) {
      this.trapFocus(event);
    }
  };

  PTMobileMenu.prototype.trapFocus = function (event) {
    var focusable = this.getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      this.drawer.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || active === this.drawer) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (active === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  PTMobileMenu.prototype.onOverlayClick = function (event) {
    event.preventDefault();
    this.close();
  };

  PTMobileMenu.prototype.onCloseClick = function (event) {
    event.preventDefault();
    this.close();
  };

  PTMobileMenu.prototype.destroy = function () {
    this.close();
    if (this.overlay) {
      this.overlay.removeEventListener('click', this.onOverlayClick);
    }
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.onCloseClick);
    }
    this.root.removeAttribute('data-pt-mm-ready');
  };

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll('[data-pt-mm]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root.ptMobileMenu) {
        root.ptMobileMenu = new PTMobileMenu(root);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target ? event.target.querySelector('[data-pt-mm]') : null;
    if (root && root.ptMobileMenu) {
      root.ptMobileMenu.destroy();
      root.ptMobileMenu = null;
    }
  });

  window.PTMobileMenu = PTMobileMenu;
})();
